import React from 'react';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
class TerritoryTeam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: this.props.items?this.props.items:[]
        };
    }
    componentWillReceiveProps(nextProps, prevProps){
        if(JSON.stringify(nextProps)!=JSON.stringify(prevProps)){
            this.setState({items:nextProps.items});
        }
    }
   
     render() {
        const {
            theme,
            value,
            valueKey,
            percentKey,
            label,
            percentLabel,
            disabled,
            data,
            isFilter,
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            ...rest
        } = this.props;
        const { items } = this.state;
      
        let itemsSorted = items.filter((obj,index) =>{ 
            return index === items.findIndex(o=> obj.agent_name === o.agent_name)
        });

        itemsSorted.sort((a,b) => {
            if(a.agent_name < b.agent_name) return -1;
            if(a.agent_name > b.agent_name) return 1;
            return 0;
        })
        itemsSorted = itemsSorted.filter(item => item.agent_name != 'null null' && item.agent_name != null && item.agent_name != undefined && item.agent_name != ' ');
        return (
            <Dropdown theme={theme}
                      optionsType='territory'
                      optionKey='agent_id'
                      optionLabelKey='agent_name'
                      options={itemsSorted}
                      value={value}
                      valueKey={valueKey}
                      percentKey={percentKey}
                      label={label}
                      percentLabel={percentLabel}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      groupBy={true}
                      handleParentChange={handleParentChange}
                      handleInputParentChange={handleInputParentChange}
                      viewMode={viewMode}
                      deleted={deleted}
                      isFromProperty={isFromProperty}
                      hasAgentPercent={hasAgentPercent}
                      {...rest}
            />
        )
    }
}

TerritoryTeam.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
    items:PropTypes.array
};

export default TerritoryTeam;
